/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addDeliveryOrderDetailToDeliveryOrder } from '../fn/delivery-order/add-delivery-order-detail-to-delivery-order';
import { AddDeliveryOrderDetailToDeliveryOrder$Params } from '../fn/delivery-order/add-delivery-order-detail-to-delivery-order';
import { completeDeliveryOrder } from '../fn/delivery-order/complete-delivery-order';
import { CompleteDeliveryOrder$Params } from '../fn/delivery-order/complete-delivery-order';
import { createDeliveryOrder } from '../fn/delivery-order/create-delivery-order';
import { CreateDeliveryOrder$Params } from '../fn/delivery-order/create-delivery-order';
import { DeliveryOrder } from '../models/delivery-order';
import { deliveryOrdersUuidSupportingFileGet } from '../fn/delivery-order/delivery-orders-uuid-supporting-file-get';
import { DeliveryOrdersUuidSupportingFileGet$Params } from '../fn/delivery-order/delivery-orders-uuid-supporting-file-get';

@Injectable({ providedIn: 'root' })
export class DeliveryOrderApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createDeliveryOrder()` */
  static readonly CreateDeliveryOrderPath = '/delivery-orders';

  /**
   * Create a new delivery order.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDeliveryOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDeliveryOrder$Response(params: CreateDeliveryOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryOrder>> {
    const obs = createDeliveryOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new delivery order.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createDeliveryOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDeliveryOrder(params: CreateDeliveryOrder$Params, context?: HttpContext): Observable<DeliveryOrder> {
    const resp = this.createDeliveryOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DeliveryOrder>): DeliveryOrder => r.body)
    );
  }

  /** Path part for operation `deliveryOrdersUuidSupportingFileGet()` */
  static readonly DeliveryOrdersUuidSupportingFileGetPath = '/delivery-orders/{uuid}/supporting-file';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deliveryOrdersUuidSupportingFileGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryOrdersUuidSupportingFileGet$Response(params: DeliveryOrdersUuidSupportingFileGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = deliveryOrdersUuidSupportingFileGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deliveryOrdersUuidSupportingFileGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deliveryOrdersUuidSupportingFileGet(params: DeliveryOrdersUuidSupportingFileGet$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.deliveryOrdersUuidSupportingFileGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `completeDeliveryOrder()` */
  static readonly CompleteDeliveryOrderPath = '/delivery-orders/{uuid}/complete';

  /**
   * Complete the delivery order after reconciliation of the invoice.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `completeDeliveryOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  completeDeliveryOrder$Response(params: CompleteDeliveryOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryOrder>> {
    const obs = completeDeliveryOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Complete the delivery order after reconciliation of the invoice.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `completeDeliveryOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  completeDeliveryOrder(params: CompleteDeliveryOrder$Params, context?: HttpContext): Observable<DeliveryOrder> {
    const resp = this.completeDeliveryOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DeliveryOrder>): DeliveryOrder => r.body)
    );
  }

  /** Path part for operation `addDeliveryOrderDetailToDeliveryOrder()` */
  static readonly AddDeliveryOrderDetailToDeliveryOrderPath = '/delivery-orders/{uuid}/details';

  /**
   * Add a delivery order detail to an existing delivery order.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addDeliveryOrderDetailToDeliveryOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addDeliveryOrderDetailToDeliveryOrder$Response(params: AddDeliveryOrderDetailToDeliveryOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryOrder>> {
    const obs = addDeliveryOrderDetailToDeliveryOrder(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add a delivery order detail to an existing delivery order.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addDeliveryOrderDetailToDeliveryOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addDeliveryOrderDetailToDeliveryOrder(params: AddDeliveryOrderDetailToDeliveryOrder$Params, context?: HttpContext): Observable<DeliveryOrder> {
    const resp = this.addDeliveryOrderDetailToDeliveryOrder$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DeliveryOrder>): DeliveryOrder => r.body)
    );
  }

}
